import { useContext } from 'react';
import { BlazeAuthContext } from './BlazeAuthContext';

const useBlazeAuthContext = () => useContext(BlazeAuthContext);

export { useBlazeAuthContext };
